<template>
  <div id="myDatePicker" class="clearfix">
    <div class="type-box">
      <div :class="{'active':dateType == 3}" @click="dateType=3">
        <span>日</span>
      </div>
      <div :class="{'active':dateType == 5}" @click="dateType=5">
        <span>月</span>
      </div>
      <div :class="{'active':dateType == 7}" @click="dateType=7">
        <span>年</span>
      </div>
    </div>
    <div class="picker" v-if="type==1">
      <el-date-picker v-model="value" :type="pickerType" @change="changeDate" value-format="yyyy-MM-dd"
        :picker-options="pickerOptions0" placeholder="选择日期">
      </el-date-picker>
      </el-date-picker>
    </div>

    <div class="picker" v-if="type==2">
      <el-date-picker v-model="dayTime" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart"
        placeholder="选择日期" @change="changeDate" v-show="dateType==3">
      </el-date-picker>
      <el-date-picker v-model="monthTime" type="month" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart"
        placeholder="选择月份" @change="changeDate" v-show="dateType==5">
      </el-date-picker>
      <el-date-picker v-model="yearTime" type="year" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart"
        placeholder="选择年份" @change="changeDate" v-show="dateType==7">
      </el-date-picker>
      <!--<span style="font-size: 14px; margin: 0 12px;">至</span>
      <el-date-picker v-model="value3" :type="pickerType" value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd"
        placeholder="结束日期" @change="changeDate">
      </el-date-picker> -->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dateType: 5,  //1分钟，2小时，3天，4周，5月，6季度，7年
        value: "",
        value2: "",
        value3: "",
        yearTime:null,
        monthTime:null,
        dayTime:null,
        // 今天及以前的时间
        pickerOptionsStart: {
          disabledDate: (time) => {
            if (this.dateType != 7) {
              if (this.value3) {
                return time.getTime() > Date.now() - this.cutTime || time.getTime() > new Date(this.value3).getTime();
              } else {
                return time.getTime() > Date.now() - this.cutTime;
              }
            } else {
              if (this.value3) {
                return time.getFullYear() > new Date().getFullYear() - 1 || time.getFullYear() < new Date(this.value3)
                  .getFullYear() - 1;
              } else {
                return time.getFullYear() > new Date().getFullYear() - 1
              }
            }
          }
        },
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
        cutTime: 1000 * 3600 * 24,
        pickerOptionsStart1: {
          disabledDate: (time) => {
            return time.getTime() > Date.now() - 1000 * 3600 * 24;
          }
        },
        pickerOptionsStart2: {
          disabledDate: (time) => {
            return time.getTime() > Date.now() - 1000 * 3600 * 24 * 30;
          }
        },
        pickerOptionsStart3: {
          disabledDate: (time) => {
            return time.getTime() > Date.now() - 1000 * 3600 * 24 * 30 * 365;
          }
        },
      }
    },
    props: {
      type: {
        default: 2,
        type: Number
      },
      today: {
        default: false,
        type: Boolean
      },
    },
    computed: {
      pickerType() {
        if (this.dateType == 5) {
          return 'month'
        } else if (this.dateType == 7) {
          return 'year'
        } else {
          return 'date'
        }
      },
    },
    created() {
      if(this.type == 2){
         this.cutTime = 1000 * 3600 * 24 * 30
        // 默认选中上个月
        var month = new Date().getMonth()
        var time = new Date().setMonth(month -1 )
        var year = new Date(time).getFullYear()
        month = new Date(time).getMonth()+1
        this.value2 = year + '-' + month + '-01'
        this.monthTime = this.value2
        var lastDay = year + '-' + month + '-' + this.getLastDayOfMonth(year,month);
        this.$emit("changeTime", [this.value2,lastDay],this.dateType)
        //设定 默认的去年和昨天时间
        var Year = new Date().getFullYear()   //今年
        var lastYear = new Date().setFullYear(Year-1)  //去年
        Year = new Date(lastYear).getFullYear() //去年的年份
        this.yearTime = Year+'-01-01'
        var Day = new Date().getDate()  //今天
        var lastDay = new Date().setDate(Day -1)  //昨天
        Year = new Date(lastDay).getFullYear()  //昨天的年份
        var Month = new Date(lastDay).getMonth()+1  //昨天的月份
        var Day = new Date(lastDay).getDate()       //昨天的日期
        this.dayTime = Year + '-' + Month + '-' + Day
      }else{
        this.dateType = 3
        var year = new Date().getFullYear()
        var month = new Date().getMonth() + 1
        var day = new Date().getDate()
        this.value = year + '-' + month + '-' + day
        this.dayTime = this.value
        this.monthTime = year + '-' + month + '-01'
        this.yearTime = year+ '-01-01'
        this.$emit("changeTime", this.value,this.dateType)
      }
      this.$forceUpdate()
    },
    methods: {
      changeDate(e) {
        if (this.type == 1) {
          let time=''
          if(this.dateType == 3){
            this.dayTime = this.value
          }else if(this.dateType == 5){
            this.monthTime = this.value
          }else{
            this.yearTime = this.value
          }
          this.$emit("changeTime", this.value,this.dateType)
        } else{
          if (this.dateType == 3) {
            this.$emit("changeTime", [this.dayTime,this.dayTime],this.dateType)
          } else if (this.dateType == 5) {
            let arr = this.monthTime.split('-');
            let endDay = this.getLastDayOfMonth(arr[0],arr[1]);
            let startTime = arr[0]+'-'+arr[1]+'-01';
            let lastTime = arr[0]+'-'+arr[1]+'-'+endDay;
            this.$emit("changeTime", [startTime,lastTime],this.dateType)
          } else {
            let arr = this.yearTime.split('-');
            let endDay = this.getLastDayOfMonth(arr[0],12);
            let startTime = arr[0]+'-01-01';
            let lastTime = arr[0]+'-12-'+endDay;
            this.$emit("changeTime", [startTime,lastTime],this.dateType)
          }
        }
      },
      getLastDayOfMonth(year, month) {
        //获取本年本月的第一天日期
        var date = new Date(year, month - 1, '01');
        //设置日期
        date.setDate(1);
        //设置月份
        date.setMonth(date.getMonth() + 1);
        //获取本月的最后一天
        var cdate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
        //打印某年某月的最后一天
        //返回结果
        return cdate.getDate();
      }
    },
    watch: {
      dateType() {
        let type = this.type
        if (this.dateType == 3) {
          this.cutTime = 1000 * 3600 * 24
        } else if (this.dateType == 5) {
          this.cutTime = 1000 * 3600 * 24 * 30
        } else {
          this.cutTime = 1000 * 3600 * 24 * 30 * 365
        }
        if(this.type==2){
          if (this.dateType == 3) {
            this.value2 = this.dayTime
            if(this.value2){
              this.$emit("changeTime", [this.value2,this.value2],this.dateType)
            }
          } else if (this.dateType == 5) {
            this.value2 = this.monthTime
            if(this.value2){
              let arr = this.value2.split('-');
              let endDay = this.getLastDayOfMonth(arr[0],arr[1]);
              let startTime = arr[0]+'-'+arr[1]+'-01';
              let lastTime = arr[0]+'-'+arr[1]+'-'+endDay;
              this.$emit("changeTime", [startTime,lastTime],this.dateType)
            }
          } else if(this.dateType == 7) {
            // console.log(this.yearTime)
            this.value2 = this.yearTime
            if(this.value2){
              let arr = this.value2.split('-');
              let endDay = this.getLastDayOfMonth(arr[0],12);
              let startTime = arr[0]+'-01-01';
              let lastTime = arr[0]+'-12-'+endDay;
              this.$emit("changeTime", [startTime,lastTime],this.dateType)
            }
          }
        }else{
          if (this.dateType == 3&&this.value) {
            this.value = this.dayTime
          } else if (this.dateType == 5&&this.value) {
            this.value = this.monthTime
          } else if(this.dateType == 7&&this.value) {
            this.value = this.yearTime
          }
          if(this.value){
            this.$emit("changeTime", this.value,this.dateType)
          }
        }
        this.$forceUpdate()
      }
    }
  }
</script>

<style scoped>
  .picker {
    float: left;
    margin-left: 20px;
  }

  .type-box {
    text-align: center;
    float: left;
    height: 40px;
    overflow: hidden;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border: 1px solid #d2d2d2;
    box-sizing: border-box;
  }

  .type-box div {
    float: left;
    padding: 9px 0;
    -webkit-transition: .1s;
    transition: .1s;
    cursor: pointer;
  }

  .type-box div.active {
    background: #5087e4;
    color: #fff;
  }

  .type-box>div:first-child span {
    border: none;
  }

  .type-box span {
    display: inline-block;
    width: 50px;
    font-size: 14px;
    line-height: 22px;
    border-left: 1px solid #e2e2e2;
    float: left;
  }

  .active>span {
    border: 0;
  }
</style>
<style>
  #myDatePicker .el-month-table td.today .cell{
    color: #606266 !important;
    font-weight: 500 !important;
  }
  #myDatePicker .el-month-table td.current:not(.disabled) .cell{
    font-weight: 700 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/MyDatePicket.vue